import { Col, Modal, Button } from "react-bootstrap";
import { useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import 'react-multi-carousel/lib/styles.css';
import React, { forwardRef, useEffect } from 'react';

import ProjectDetailsModal from './ProjectDetails';
import no_client_review from "../assets/img/client_no_review.png";

import gmaps_img from "../assets/img/skills/gmaps_logo.png";
import admob_img from "../assets/img/skills/admob_logo.png";
import coroutines_img from "../assets/img/skills/coroutines_logo.png";
import daggerhilt_img from "../assets/img/skills/daggerhilt_logo.png";
import expresso_img from "../assets/img/skills/espresso_logo.png";
import filament_img from "../assets/img/skills/filament_logo.png";
import java_img from "../assets/img/skills/java_logo.png";
import mvc_img from "../assets/img/skills/mvc_logo.png";
import opencv_img from "../assets/img/skills/opencv_logo.png";
import python_img from "../assets/img/skills/python_logo.png";
import retrofit_img from "../assets/img/skills/retrofit_logo.png";
import tensorflow_img from "../assets/img/skills/tensorflow_logo.png";
import github_img from "../assets/img/skills/github_logo.png";
import xml_img from "../assets/img/skills/xml_logo.png";
import room_img from "../assets/img/skills/room_logo.png";
import nodejs_img from "../assets/img/skills/nodejs_logo.png";
import postgres_img from "../assets/img/skills/postgres_logo.png";
import mvvm_img from "../assets/img/skills/mvvm_logo.png";
import xd_img from "../assets/img/skills/xd_logo.png";
import kotlin_img from "../assets/img/skills/kotlin_logo.png";
import firebase_img from "../assets/img/skills/firebase_logo.png";


import fb1 from "../assets/img/screenshots/fb1.jpg";
import fb2 from "../assets/img/screenshots/fb2.jpg";
import fb3 from "../assets/img/screenshots/fb3.jpg";
import fb4 from "../assets/img/screenshots/fb4.jpg";
import fb5 from "../assets/img/screenshots/fb5.jpg";
import fb6 from "../assets/img/screenshots/fb6.jpg";
import fb7 from "../assets/img/screenshots/fb7.jpg";
import fb8 from "../assets/img/screenshots/fb8.jpg";
import fb9 from "../assets/img/screenshots/fb9.jpg";
import fb10 from "../assets/img/screenshots/fb10.jpg";
import fb11 from "../assets/img/screenshots/fb11.jpg";
import fb12 from "../assets/img/screenshots/fb12.jpg";
import fb13 from "../assets/img/screenshots/fb13.jpg";
import fb14 from "../assets/img/screenshots/fb14.jpg";
import fb15 from "../assets/img/screenshots/fb15.jpg";
import fb16 from "../assets/img/screenshots/fb16.jpg";
import fb17 from "../assets/img/screenshots/fb17.jpg";
import fb18 from "../assets/img/screenshots/fb18.jpg";
import fb19 from "../assets/img/screenshots/fb19.jpg";
import fb20 from "../assets/img/screenshots/fb20.jpg";

import fdv1 from "../assets/img/screenshots/fdv1.jpg";
import fdv2 from "../assets/img/screenshots/fdv2.jpg";
import fdv3 from "../assets/img/screenshots/fdv3.jpg";
import fdv4 from "../assets/img/screenshots/fdv4.jpg";
import fdv5 from "../assets/img/screenshots/fdv5.jpg";
import fdv6 from "../assets/img/screenshots/fdv6.jpg";
import fdv7 from "../assets/img/screenshots/fdv7.jpg";
import fdv8 from "../assets/img/screenshots/fdv8.jpg";

import qz1 from "../assets/img/screenshots/qz1.jpg";
import qz2 from "../assets/img/screenshots/qz2.jpg";
import qz3 from "../assets/img/screenshots/qz3.jpg";
import qz4 from "../assets/img/screenshots/qz4.jpg";
import qz5 from "../assets/img/screenshots/qz5.jpg";
import qz6 from "../assets/img/screenshots/qz6.jpg";
import qz7 from "../assets/img/screenshots/qz7.jpg";
import qz8 from "../assets/img/screenshots/qz8.jpg";
import qz9 from "../assets/img/screenshots/qz9.jpg";
import qz10 from "../assets/img/screenshots/qz10.jpg";
import qz11 from "../assets/img/screenshots/qz11.jpg";

import rn1 from "../assets/img/screenshots/rn1.jpg";
import rn2 from "../assets/img/screenshots/rn2.jpg";
import rn3 from "../assets/img/screenshots/rn3.jpg";
import rn4 from "../assets/img/screenshots/rn4.jpg";
import rn5 from "../assets/img/screenshots/rn5.jpg";
import rn6 from "../assets/img/screenshots/rn6.jpg";
import rn7 from "../assets/img/screenshots/rn7.jpg";
import rn8 from "../assets/img/screenshots/rn8.jpg";
import rn9 from "../assets/img/screenshots/rn9.jpg";
import rn10 from "../assets/img/screenshots/rn10.jpg";

import ec1 from "../assets/img/screenshots/ec1.jpg";
import ec2 from "../assets/img/screenshots/ec2.jpg";
import ec3 from "../assets/img/screenshots/ec3.jpg";
import ec4 from "../assets/img/screenshots/ec4.jpg";
import ec5 from "../assets/img/screenshots/ec5.jpg";
import ec6 from "../assets/img/screenshots/ec6.jpg";
import ec7 from "../assets/img/screenshots/ec7.jpg";

import plt1 from "../assets/img/screenshots/plt1.jpg";
import plt2 from "../assets/img/screenshots/plt2.jpg";
import plt3 from "../assets/img/screenshots/plt3.jpg";
import plt4 from "../assets/img/screenshots/plt4.jpg";
import plt5 from "../assets/img/screenshots/plt5.jpg";

import key1 from "../assets/img/screenshots/key1.jpg";
import key2 from "../assets/img/screenshots/key2.jpg";
import key3 from "../assets/img/screenshots/key3.jpg";
import key4 from "../assets/img/screenshots/key4.jpg";
import key5 from "../assets/img/screenshots/key5.jpg";
import key6 from "../assets/img/screenshots/key6.jpg";
import key7 from "../assets/img/screenshots/key7.jpg";

import sw1 from "../assets/img/screenshots/sw1.jpg";
import sw2 from "../assets/img/screenshots/sw2.jpg";
import sw3 from "../assets/img/screenshots/sw3.jpg";
import sw4 from "../assets/img/screenshots/sw4.jpg";
import sw5 from "../assets/img/screenshots/sw5.jpg";
import sw6 from "../assets/img/screenshots/sw6.jpg";
import sw7 from "../assets/img/screenshots/sw7.jpg";
import sw8 from "../assets/img/screenshots/sw8.jpg";

import lvn1 from "../assets/img/screenshots/Livein Tenant SS 1.jpg";
import lvn2 from "../assets/img/screenshots/Livein Tenant SS 2.jpg";
import lvn3 from "../assets/img/screenshots/Livein Tenant SS 3.jpg";
import lvn4 from "../assets/img/screenshots/Livein Tenant SS 4.jpg";
import lvn5 from "../assets/img/screenshots/Livein Tenant SS 5.jpg";
import lvn6 from "../assets/img/screenshots/Livein Tenant SS 6.jpg";

import wflow1 from "../assets/img/screenshots/Wflow Monitor SS 1.jpg";

import psh1 from "../assets/img/screenshots/PSH SS 1.jpg";
import psh2 from "../assets/img/screenshots/PSH SS 2.jpg";
import psh3 from "../assets/img/screenshots/PSH SS 3.jpg";
import psh4 from "../assets/img/screenshots/PSH SS 4.jpg";
import psh5 from "../assets/img/screenshots/PSH SS 5.jpg";
import psh6 from "../assets/img/screenshots/PSH SS 6.jpg";
import psh7 from "../assets/img/screenshots/PSH SS 7.jpg";
import psh8 from "../assets/img/screenshots/PSH SS 8.jpg";
import psh9 from "../assets/img/screenshots/PSH SS 9.jpg";
import psh10 from "../assets/img/screenshots/PSH SS 10.jpg";

import hpt1 from "../assets/img/screenshots/Happy Pet SS 1.jpg";
import hpt2 from "../assets/img/screenshots/Happy Pet SS 2.jpg";
import hpt3 from "../assets/img/screenshots/Happy Pet SS 3.jpg";
import hpt4 from "../assets/img/screenshots/Happy Pet SS 4.jpg";
import hpt5 from "../assets/img/screenshots/Happy Pet SS 5.jpg";

import repo1 from "../assets/img/screenshots/Reporite-SS-1.jpg";
import repo2 from "../assets/img/screenshots/Reporite-SS-2.jpg";
import repo3 from "../assets/img/screenshots/Reporite-SS-3.jpg";
import repo4 from "../assets/img/screenshots/Reporite-SS-4.jpg";
import repo5 from "../assets/img/screenshots/Reporite-SS-5.jpg";


import ugd1 from "../assets/img/screenshots/Uguardian SS 1.jpg";
import ugd2 from "../assets/img/screenshots/Uguardian SS 2.jpg";
import ugd3 from "../assets/img/screenshots/Uguardian SS 3.jpg";
import ugd4 from "../assets/img/screenshots/Uguardian SS 4.jpg";
import ugd5 from "../assets/img/screenshots/Uguardian SS 5.jpg";
import ugd6 from "../assets/img/screenshots/Uguardian SS 6.jpg";
import ugd7 from "../assets/img/screenshots/Uguardian SS 7.jpg";
import ugd8 from "../assets/img/screenshots/Uguardian SS 8.jpg";
import ugd9 from "../assets/img/screenshots/Uguardian SS 9.jpg";
import ugd10 from "../assets/img/screenshots/Uguardian SS 10.jpg";


import lvnVid from "../assets/video/Livein Tenant SR.mp4";
import pshVid from "../assets/video/PS Healthcare SR.mp4";
import hptVid from "../assets/video/Happy Pet SR.mp4";
import ugdVid from "../assets/video/Uguardian SR.mp4";
import fbVid from "../assets/video/Funbay.mp4";
import fdvVid from "../assets/video/Foodiv.mp4";
import qzVid from "../assets/video/Quizard.mp4";
import rnVid from "../assets/video/Rnn Academy.mp4";
import ecVid from "../assets/video/Blank.mp4";
import pltVid from "../assets/video/Planto.mp4";
import keyVid from "../assets/video/Pastie.mp4";
import swVid from "../assets/video/Skywatch.mp4";
import wflowVid from "../assets/video/Blank.mp4";
import reporiteVid from "../assets/video/Reporite.mp4";

import VideoPlayer from '../components/CustomVideoPlayer';

// import project_card_1 from "../assets/img/project_card_1.png";


export const ProjectCard = ({ id, title, description, imgUrl }) => {
  const [showDetailsPopup, setShowDetailsPopup] = useState(false);
  const [showVideoPopup, setShowVideoPopup] = useState(false);
  const [activeId, setActiveId] = useState(null);


  // Listen for custom events to open video
  useEffect(() => {
    const handleOpenVideo = (event) => {
      if (event.detail.projectId === id) {
        setActiveId(id);
        setShowVideoPopup(true);
      }
    };

    const handleOpenDetails = (event) => {
      if (event.detail.projectId === id) {
        setActiveId(id);
        setShowDetailsPopup(true);
      }
    };

    window.addEventListener('openProjectVideo', handleOpenVideo);
    window.addEventListener('openProjectDetails', handleOpenDetails);

    return () => {
      window.removeEventListener('openProjectVideo', handleOpenVideo);
      window.removeEventListener('openProjectDetails', handleOpenDetails);
    };
  }, [id]);

  const handleShowVideoPopup = () => {
    setActiveId(id);
    setShowVideoPopup(true);
  };

  const handleShowDetailsPopup = () => {
    setActiveId(id);
    setShowDetailsPopup(true);
  };

  const handleCloseVideoPopup = () => setShowVideoPopup(false);
  const handleCloseDetailsPopup = () => setShowDetailsPopup(false);

  // Get video source based on project id
  const getVideoSource = () => {
    switch (id) {
      case 11: return lvnVid;
      case 10: return pshVid;
      case 9: return fbVid;
      case 8: return qzVid;
      case 7: return ugdVid;
      case 6: return fdvVid;
      case 5: return rnVid;
      case 4: return ecVid;
      case 3: return hptVid;
      case 2: return pltVid;
      case 1: return keyVid;
      case 102: return reporiteVid;
      case 101: return swVid;
      case 100: return wflowVid;
      default: return null;
    }
  };

  // Render different content based on the activeId state
  const renderDetailsContent = () => {
    switch (activeId) {
      case 11:
        return (
          <ProjectDetailsModal
            title="Livein Tenant"
            screenshots={[lvn6, lvn1, lvn2, lvn3, lvn4, lvn5]}
            demoVideoSource={lvnVid}
            description={
              <>
                Livein Tenant: Simplify Society Living, Payments & Events : <br /><br />
                ✅ Track Society Finances<br />
                ✅ Pay Bills Instantly<br />
                ✅ Book Facilities<br />
                ✅ Stay Updated on Events<br />
                ✅ Resident Directory<br />
                🔒 Secure & Encrypted: All financial data and resident details are protected.<br />
                🏘️ For Everyone: Perfect for apartments, gated communities, and housing societies.<br />
              </>
            }
            technologiesUsed={[kotlin_img, mvvm_img, xml_img, retrofit_img, coroutines_img, xd_img, github_img]}
            technologiesUsedNames={["Kotlin", "MVVM Architecture", "XML", "Retrofit", "Coroutines", "AdobeXD", "Github"]}
            clientReviewImage={no_client_review}
            projectDemoText="Check out the demo app by downloading apk from below."
            downloadAPKLink={"https://drive.google.com/uc?export=download&id=1SMsTdqH99mNpbYU9thK98GOWh4Ca2E8d"}
          />
        );
      case 10:
        return (
          <ProjectDetailsModal
            title="PS Healthcare"
            screenshots={[psh1, psh2, psh3, psh4, psh5, psh6, psh7, psh8, psh9, psh10]}
            demoVideoSource={pshVid}
            description={
              <>
                PS Healthcare: Book lab tests with ease and keep track of all your appointments : <br /><br />
                ✅ Explore from the collection of 1000+ lab tests offered by PS Healthcare Labs<br />
                ✅ Book common lab test packages<br />
                ✅ Get Lab reports and status at your fingertips<br />
                ✅ Explore blogs related to healthcare<br />
                ✅ Add family members to book on their behalf<br />
                ✅ Upload Prescription to get a call<br />
                🔒 Secure & Encrypted: All personal health data is protected.<br />
              </>
            }
            technologiesUsed={[kotlin_img, mvvm_img, xml_img, retrofit_img, coroutines_img, xd_img, github_img]}
            technologiesUsedNames={["Kotlin", "MVVM Architecture", "XML", "Retrofit", "Coroutines", "AdobeXD", "Github"]}
            clientReviewImage={no_client_review}
            projectDemoText="Check out the demo app by downloading apk from below."
            downloadAPKLink={"https://drive.google.com/uc?export=download&id=1SMsTdqH99mNpbYU9thK98GOWh4Ca2E8d"}
          />
        );
      case 9:
        return (
          <ProjectDetailsModal
            title="Funbay"
            screenshots={[fb1, fb2, fb3, fb4, fb5, fb6, fb7, fb8, fb9, fb10, fb11, fb12, fb13, fb14, fb15, fb16, fb17, fb18, fb19, fb20]}
            demoVideoSource={fbVid}
            description={
              <>
                Funbay is an Entertainment application which has a wide range of movies and Tv shows with a seperate section for Anime Fans<br />
                Some of the features offered by the application are listed below : <br /><br />
                ✔️ Popular Movies<br />
                ✔️ Top Rated Movies<br />
                ✔️ Upcoming Movies<br />
                ✔️ Popular Tv Shows<br />
                ✔️ Top Rated Tv Shows<br />
                ✔️ Upcoming Tv Shows<br />
                ✔️ Anime Movies<br />
                ✔️ Anime Tv Shows<br />
                ✔️ 5 different locations<br />
                ✔️ Favourites List <br />
              </>
            }
            technologiesUsed={[java_img, mvc_img, xml_img, room_img, github_img]}
            technologiesUsedNames={["Java", "MVC Architecture", "XML", "Room Database", "Github"]}
            clientReviewImage={no_client_review}
            projectDemoText="Check out the demo app by downloading apk from below."
            downloadAPKLink={"https://drive.google.com/uc?export=download&id=1aifsNqAhJXR_cdr9TUMaOVM9QbxNgtFS"}
          />

        );
      case 8:
        return (
          <ProjectDetailsModal
            title="Quizard"
            screenshots={[qz1, qz2, qz3, qz4, qz5, qz6, qz7, qz8, qz9, qz10, qz11]}
            demoVideoSource={qzVid}
            description={
              <>
                Quizard is an Competitive exams Educational quiz and social meadia blocking app which provide students a focuced approach towards test series <br />
                Some of the features offered by the application are listed below : <br /><br />
                ✔️ Normal Quizzes<br />
                ✔️ Rapid Fire Quizzes<br />
                ✔️ Social Media Blocking<br />
                ✔️ Social apps usage stats<br />
                ✔️ Web Admin Panel<br />
                ✔️ Random Browsing Pop Quizzes<br />
                ✔️ User Profile<br />
              </>
            }
            technologiesUsed={[kotlin_img, mvc_img, xml_img, firebase_img, coroutines_img, xd_img, github_img]}
            technologiesUsedNames={["Kotlin", "MVC Architecture", "XML", "Firebase Database", "Coroutines", "AdobeXD", "Github"]}
            clientReviewImage={no_client_review}
            projectDemoText="Check out the demo app by downloading apk from below."
            downloadAPKLink={"https://drive.google.com/uc?export=download&id=1_MlDoknUaJxSnaF89ZtARycvmRaQDOkL"}
          />

        );
      case 7:
        return (
          <ProjectDetailsModal
            title="Uguardian"
            screenshots={[ugd1, ugd2, ugd3, ugd4, ugd5, ugd6, ugd7, ugd8, ugd9, ugd10]}
            demoVideoSource={ugdVid}
            description={
              <>
                Uguardian: Feel safe with precise and all time active SOS app <br /><br />
                ✅ Car crash detection<br />
                ✅ Set Emergency Phrase<br />
                ✅ Automatic location sending to Emergency contacts<br />
                ✅ Automatic location sending to Family contacts<br />
                ✅ Contact nearby hospitals in an Emergency<br />
              </>
            }
            technologiesUsed={[kotlin_img, mvvm_img, xml_img, retrofit_img, coroutines_img, xd_img, github_img]}
            technologiesUsedNames={["Kotlin", "MVVM Architecture", "XML", "Retrofit", "Coroutines", "AdobeXD", "Github"]}
            clientReviewImage={no_client_review}
            projectDemoText="Check out the demo app by downloading apk from below."
            downloadAPKLink={"https://drive.google.com/uc?export=download&id=1SMsTdqH99mNpbYU9thK98GOWh4Ca2E8d"}
          />
        );
      case 6:
        return (
          <ProjectDetailsModal
            title="Foodiv"
            screenshots={[fdv1, fdv2, fdv3, fdv4, fdv5, fdv6, fdv7, fdv8]}
            demoVideoSource={fdvVid}
            description={
              <>
                Foodiv is a Food Delivery Project which has total of 3 apps : User app, Restaurants app, Driver App<br />
                Some of the features offered by the application are listed below : <br /><br />
                ✔️ Restaurants list based on loacation<br />
                ✔️ Foods listed by multiple Restaurants<br />
                ✔️ Cart Functionality<br />
                ✔️ Restaurants App<br />
                ✔️ Driver App<br />
                ✔️ Web Admin Panel<br />
                ✔️ User Profile<br />
              </>
            }
            technologiesUsed={[kotlin_img, mvc_img, xml_img, firebase_img, coroutines_img, xd_img, github_img]}
            technologiesUsedNames={["Kotlin", "MVC Architecture", "XML", "Firebase Database", "Coroutines", "AdobeXD", "Github"]}
            clientReviewImage={no_client_review}
            projectDemoText="Check out the demo app by downloading apk from below."
            downloadAPKLink={"https://drive.google.com/uc?export=download&id=1gAFx6RZEp9zmepEv_UZPPZcPVvXHXA-8"}
          />

        );
      case 5:
        return (
          <ProjectDetailsModal
            title="Rnn Academy"
            screenshots={[rn1, rn2, rn3, rn4, rn5, rn6, rn7, rn8, rn9, rn10]}
            demoVideoSource={rnVid}
            description={
              <>
                Rnn Academy is an educational app focused on providing video lectures and quizzes in the field of Nursing, The app contains multiple lectures along with multiple videos in each leactures with their respective quizzes <br />
                Some of the features offered by the application are listed below : <br /><br />
                ✔️ Multiple Nursing Courses<br />
                ✔️ Save to Favourites<br />
                ✔️ Multiple Lectures<br />
                ✔️ Multiple Videos in a Lecture<br />
                ✔️ Dual Language Quiz<br />
                ✔️ User Profiles<br />
                ✔️ Web Admin Panel<br />
              </>
            }
            technologiesUsed={[kotlin_img, mvc_img, xml_img, firebase_img, retrofit_img, coroutines_img, xd_img, github_img]}
            technologiesUsedNames={["Kotlin", "MVC Architecture", "XML", "Firebase Database", "Retrofit", "Coroutines", "AdobeXD", "Github"]}
            clientReviewImage={no_client_review}
            projectDemoText="Check out the demo app by downloading apk from below."
            downloadAPKLink={"https://drive.google.com/uc?export=download&id=1MR2KZ9HO2fs84iopE7ZJj30ja55-JRcg"}
          />

        );
      case 4:
        return (
          <ProjectDetailsModal
            title="Echo"
            screenshots={[ec1, ec2, ec3, ec4, ec5, ec6, ec7]}
            demoVideoSource={ecVid}
            description={
              <>
                Echo is an ecommerce app which provides electronic components and Electronic Projects also with the 3d view of the both, this helps echo to stay an engaging ecommerce platform. Echo also provides Articles for users who want to build their project from scratch <br />
                Some of the features offered by the application are listed below : <br /><br />
                ✔️ Featured Electronic Packs<br />
                ✔️ Category Filters<br />
                ✔️ 3d Item View<br />
                ✔️ Multiple Product Images<br />
                ✔️ Cart Functionality<br />
                ✔️ How to Build Arcticles<br />
                ✔️ ReadyMade Projects<br />
                ✔️ Order History<br />
                ✔️ Razorpay Integration<br />
                ✔️ Order Tracking<br />
                ✔️ Vendor App<br />
                ✔️ Web Admin Panel<br />
                ✔️ User Profiles<br />
              </>
            }
            technologiesUsed={[kotlin_img, mvc_img, xml_img, firebase_img, filament_img, coroutines_img, xd_img, github_img]}
            technologiesUsedNames={["Kotlin", "MVC Architecture", "XML", "Firebase Database", "Filament", "Coroutines", "AdobeXD", "Github"]}
            clientReviewImage={no_client_review}
            projectDemoText="Apk Not available due to feature update process, It will be availble soon"
            downloadAPKLink={""}
          />

        );
      case 3:
        return (
          <ProjectDetailsModal
            title="Happy Pet"
            screenshots={[hpt1, hpt2, hpt3, hpt4, hpt5]}
            demoVideoSource={hptVid}
            description={
              <>
                Happy Pet: Keep track of all pets appintments, meds and activities <br /><br />
                ✅ Add multiple pets<br />
                ✅ Set appointment reminders<br />
                ✅ Set Vaccination remiders<br />
                ✅ Track your pet's medications<br />
                ✅ Log pet activities<br />
                🔒 Secure & Encrypted: All pet health data is protected.<br />
              </>
            }
            technologiesUsed={[kotlin_img, mvvm_img, xml_img, retrofit_img, coroutines_img, xd_img, github_img]}
            technologiesUsedNames={["Kotlin", "MVVM Architecture", "XML", "Retrofit", "Coroutines", "AdobeXD", "Github"]}
            clientReviewImage={no_client_review}
            projectDemoText="Check out the demo app by downloading apk from below."
            downloadAPKLink={"https://drive.google.com/uc?export=download&id=1SMsTdqH99mNpbYU9thK98GOWh4Ca2E8d"}
          />
        );
      case 2:
        return (
          <ProjectDetailsModal
            title="Planto"
            screenshots={[plt1, plt2, plt3, plt4, plt5]}
            demoVideoSource={pltVid}
            description={
              <>
                Planto is an ML Application used to detect crop diseases from plant leaves, useful in farming as well as household plants <br />
                Some of the features offered by the application are listed below : <br /><br />
                ✔️ Disease identification ML Model<br />
                ✔️ Plant Discription<br />
                ✔️ Prevention Statement<br />
                ✔️ Healthy Leaves Examples<br />
                ✔️ 93% Accuracy<br />
                ✔️ User Profiles<br />
                ✔️ Gallery/Camera image Upload<br />
              </>
            }
            technologiesUsed={[kotlin_img, mvc_img, xml_img, firebase_img, opencv_img, python_img, tensorflow_img, coroutines_img, xd_img, github_img]}
            technologiesUsedNames={["Kotlin", "MVC Architecture", "XML", "Firebase Database", "Open Cv", "Python", "Tensorflow", "Coroutines", "AdobeXD", "Github"]}
            clientReviewImage={no_client_review}
            projectDemoText="Check out the demo app by downloading apk from below."
            downloadAPKLink={"https://drive.google.com/uc?export=download&id=1Nm3il8lefMAvJQNb22tSXuVaX9xlaF8w"}
          />

        );
      case 1:
        return (
          <ProjectDetailsModal
            title="Pastie Keyboard"
            screenshots={[key1, key2, key3, key4, key5, key6, key7]}
            demoVideoSource={keyVid}
            description={
              <>
                Pastie is an app which offers a keyboard service on Android with multiple copy as well as continious Paste <br />
                Some of the features offered by the application are listed below : <br /><br />
                ✔️ Keyboard Selection<br />
                ✔️ Key Preview<br />
                ✔️ Single/Multiline copy<br />
                ✔️ Copy List<br />
                ✔️ Continious Paste<br />
                ✔️ Multiple direct Sends<br />
                ✔️ Dark/Light Theme<br />
              </>
            }
            technologiesUsed={[kotlin_img, mvc_img, xml_img, firebase_img, coroutines_img, xd_img, github_img]}
            technologiesUsedNames={["Kotlin", "MVC Architecture", "XML", "Firebase Database", "Coroutines", "AdobeXD", "Github"]}
            clientReviewImage={no_client_review}
            projectDemoText="Check out the demo app by downloading apk from below."
            downloadAPKLink={"https://drive.google.com/uc?export=download&id=1VLubyjb5h48jv0AgH_r5caYzN5ThUZv8"}
          />

        );
      case 102:
        return (
          <ProjectDetailsModal
            title="Reporite"
            screenshots={[repo1, repo2, repo3, repo4, repo5]}
            demoVideoSource={reporiteVid}
            description={
              <>
                Transform your ideas into perfectly formatted documents. Generate NDAs, invoices, resumes, research papers, and more with Reporite.<br /><br />
                ✔️ Multiple templates to choose from<br />
                ✔️ Secure & encrypted data<br />
                ✔️ Fast and easy to use<br />
                ✔️ Professional quality<br />
              </>
            }
            technologiesUsed={[kotlin_img, mvvm_img, xml_img, retrofit_img, coroutines_img, xd_img, github_img]}
            technologiesUsedNames={["Kotlin", "MVVM Architecture", "XML", "Retrofit", "Coroutines", "AdobeXD", "Github"]}
            clientReviewImage={no_client_review}
            projectDemoText="Check out the demo app by downloading apk from below."
            downloadAPKLink={"https://drive.google.com/uc?export=download&id=1SMsTdqH99mNpbYU9thK98GOWh4Ca2E8d"}
          />

        );
      case 101:
        return (
          <ProjectDetailsModal
            title="Skywatch"
            screenshots={[sw1, sw2, sw3, sw4, sw5, sw6, sw7, sw8]}
            demoVideoSource={swVid}
            description={
              <>
                Skywatch is an easy to use live wheather application which shows realtime weather info based on user location in real time <br />
                Some of the features offered by the application are listed below : <br /><br />
                ✔️ Current Temperature<br />
                ✔️ Current Humidity<br />
                ✔️ Current Pressure<br />
                ✔️ Current Wind<br />
                ✔️ Clear sky info<br />
                ✔️ Min & Max Temperatures<br />
                ✔️ More info on 5 different locations<br />
              </>
            }
            technologiesUsed={[kotlin_img, mvvm_img, xml_img, retrofit_img, coroutines_img, xd_img, github_img]}
            technologiesUsedNames={["Kotlin", "MVVM Architecture", "XML", "Retrofit", "Coroutines", "AdobeXD", "Github"]}
            clientReviewImage={no_client_review}
            projectDemoText="Check out the demo app by downloading apk from below."
            downloadAPKLink={"https://drive.google.com/uc?export=download&id=1SMsTdqH99mNpbYU9thK98GOWh4Ca2E8d"}
          />

        );
      case 100:
        return (
          <ProjectDetailsModal
            title="Wflow Monitor"
            screenshots={[wflow1]}
            demoVideoSource={wflowVid}
            description={
              <>
                Wflow utilizes real-time data from humidity, temperature, sunlight, and water level sensors to optimize water usage in agricultural irrigation as well as society water usage <br /><br />
                ✔️ Soil mosture monitoring<br />
                ✔️ Humidity monitoring<br />
                ✔️ Temperature monitoring<br />
                ✔️ Water Level monitoring<br />
                ✔️ Automated water level correction<br />
                ✔️ Automated switching of water flow based on conditions<br />
              </>
            }
            technologiesUsed={[kotlin_img, mvvm_img, xml_img, retrofit_img, coroutines_img, xd_img, github_img]}
            technologiesUsedNames={["Kotlin", "MVVM Architecture", "XML", "Retrofit", "Coroutines", "AdobeXD", "Github"]}
            clientReviewImage={no_client_review}
            projectDemoText="Check out the demo app by downloading apk from below."
            downloadAPKLink={"https://drive.google.com/uc?export=download&id=1SMsTdqH99mNpbYU9thK98GOWh4Ca2E8d"}
          />

        );
      default:
        return null;
    }
  };

  return (
    <>
      <Col size={12} sm={6} md={4} className="mb-5 mt-4">
        <div className="proj-imgbx">
          <img style={{
            border: '2px solid #aa36d1', borderRadius: '15px'
          }} src={imgUrl} />
          <div className="proj-txtx">
            <h4>{title}</h4>
            <span>{description}</span>
          </div>
        </div>

        {/* Add buttons below the card */}
        <div className="d-flex justify-content-center mt-3 mb-4 gap-3">
          <button
            onClick={handleShowVideoPopup}
            className="btn btn-light btn-sm"
            style={{
              width: '100%',
              padding: '8px 15px',
              borderRadius: '10px',
              fontWeight: '500',
              color: '#333',
              border: 'none',
              boxShadow: '0 2px 5px rgba(0,0,0,0.1)'
            }}
          >
            Video
          </button>
          <button
            onClick={handleShowDetailsPopup}
            className="btn btn-light btn-sm"
            style={{
              width: '100%',
              padding: '8px 15px',
              borderRadius: '10px',
              fontWeight: '500',
              color: '#333',
              border: 'none',
              boxShadow: '0 2px 5px rgba(0,0,0,0.1)'
            }}
          >
            Details
          </button>
        </div>
      </Col>

      {/* Video Modal */}
      <Modal
        show={showVideoPopup}
        onHide={handleCloseVideoPopup}
        size="lg"
        centered
        dialogClassName="custom-dialog"
      >
        <Modal.Header
          style={{
            color: '#ffffff',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            fontWeight: 'bold',
          }}
        >
          <div style={{ flex: 1, textAlign: 'center' }}>
            <Modal.Title>Working Video</Modal.Title>
          </div>
          <div>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={handleCloseVideoPopup}
              style={{ alignSelf: 'center', backgroundColor: '#ffffff' }}
            ></button>
          </div>
        </Modal.Header>
        <Modal.Body className="p-0">
          <VideoPlayer videoSource={getVideoSource()} />
        </Modal.Body>
        <style jsx>{`
          .custom-dialog .modal-content {
            border-radius: 20px;
            max-width: 1000px;
            max-height: calc(95vh - 135px);
            overflow-y: overlay;
            background: linear-gradient(90.21deg, #AA367C -5.91%, #4A2FBD 111.58%);
          }
          .custom-dialog .modal-body {
            padding: 0;
          }
  
          .custom-dialog button.close {
            color: #231534;
          }   
        `}</style>
      </Modal>

      {/* Details Modal */}
      <Modal
        show={showDetailsPopup}
        onHide={handleCloseDetailsPopup}
        size="lg"
        centered
        dialogClassName="custom-dialog"
      >
        <Modal.Header
          style={{
            color: '#ffffff',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            fontWeight: 'bold',
          }}
        >
          <div style={{ flex: 1, textAlign: 'center' }}>
            {/* <Modal.Title>{title}</Modal.Title> */}
            <Modal.Title>Details</Modal.Title>
          </div>
          <div>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={handleCloseDetailsPopup}
              style={{ alignSelf: 'center', backgroundColor: '#ffffff' }}
            ></button>
          </div>
        </Modal.Header>
        {renderDetailsContent()}
        <style jsx>{`
          .custom-dialog .modal-content {
            border-radius: 20px;
            max-width: 1000px;
            max-height: calc(95vh - 135px);
            overflow-y: overlay;
            background: linear-gradient(90.21deg, #AA367C -5.91%, #4A2FBD 111.58%);
          }
          .custom-dialog .modal-body {
            padding: 40px;
          }
  
          .custom-dialog button.close {
            color: #231534;
          }   
        `}</style>
      </Modal>
    </>
  );
}  